define('preconfItemsShowView',[
  'module',
  'jquery',
  'underscore',
  'backbone',
  'jqgridView',
  'dateUtils',
  'urlUtil',
  'app',
  'settings',
  'template!preconfItemsViewTpl',
  'logotoolUtils',
  'datePickerPopoverMixin',
  'jqgridActionsButtonFormatterActions',
  'jqgridActionsButtonFormatterView',
  'bootbox',
  'orderUtils',
  'rolesMixin'
], function (
  module,
  $,
  _,
  Backbone,
  JqGridView,
  dateConverter,
  UrlUtil,
  App,
  Settings,
  viewTpl,
  logotoolUtils,
  datePickerPopoverMixin,
  availableActions,
  ActionButtonsView,
  bootbox,
  OrderUtils,
  RolesMixin
) {
  'use strict';

  var PreconfItemsView = JqGridView.extend({
    template: viewTpl,
    filtersName: 'preconfItemsFilters',

    regions: {
      actionsRegion: '.js-action-buttons-region'
    },

    triggers: {
      'click @ui.addNew': 'addNew' //Caught by controller
    },

    onShow: function () {
      $.material.init();
      this.updateExportUrl({});
      this.createActionButtonView();
    },

    ui: function () {
      return _.extend({
        jqGrid: '#jq-grid-list',
        jqGridPager: '#jq-grid-pager-list',
        downloadPdf: '.pdf-download',
        addNew: '.new-button',
        payedByCustomerCheckbox: '.js-ticket-payed-by-customer[type=checkbox]',
        payedToManufacturerCheckbox: '.js-ticket-payed-to-manufacturer[type=checkbox]'
      }, this.gridUi);
    },

    events: function () {
      return _.extend({
        'change @ui.payedByCustomerCheckbox': 'onPayedByCustomerCheckbox',
        'change @ui.payedToManufacturerCheckbox': 'onPayedToManufacturerCheckbox',
        'reloadData': 'reloadData'
      }, this.gridEvents);
    },
    reloadData: function () {
      this.selectedPreconfItems = [];
      this.ui.jqGrid.resetSelection();
      this.updatePagination('reloadGrid');
    },
    onPayedByCustomerCheckbox: function (e) {
      var that = this,
        $input = $(e.currentTarget),
        preconfItemId = $input.data('preconf-item-cid'),
        checked = $input.is(':checked');

      that.trigger('preconf-items:update', {purchaseOrderId: preconfItemId, payedByCustomer: checked});
    },

    onPayedToManufacturerCheckbox: function (e) {
      var that = this,
        $input = $(e.currentTarget),
        id = $input.data('preconf-item-cid'),
        checked = $input.is(':checked');

      that.trigger('preconf-items:update', {purchaseOrderId: id, payedToManufacturer: checked});
    },

    serializeData: function () {
      this.selectedPreconfItems = Settings.get('selectedPreconfItems') || [];
      var templateData = {
        'type': 'preconfItems',
        displayCreateBtn: true
      };
      return templateData;
    },

    gridOptions: function (data) {

      function displayCommentInToolTip(cellValue, rowObject) {
        if (rowObject.comments && rowObject.comments.length > 0 && rowObject.comments[0].content) {
          return ' title="' + cellValue.replace(/<(?:.|\n)*?>/gm, '') + ' \n' +
            _.i18n('common.comment') + ': ' + rowObject.comments[0].content.replaceAll('"', '\'') + '"';
        } else {
          return ' title="' + cellValue.replace(/<(?:.|\n)*?>/gm, '') + '"';
        }
      }

      var that = this,
        defaultsOptions = this.gridInitOptions(data),
        options = {
          colModel: [],

          rowattr: function () {
            return {'class': 'context-menu'};
          },

          serializeGridData: function (postData) {
            if (postData.status === that.selectDefault) {
              delete postData.status;
            }

            if (postData.createDate) {
              postData.dateFrom = datePickerPopoverMixin.parseDateFrom(postData.createDate);
              postData.dateTo = datePickerPopoverMixin.parseDateTo(postData.createDate);
            } else if (!that.sorting) {
              delete postData.dateFrom;
              delete postData.dateTo;
            }
            that.sorting = false;
            defaultsOptions.serializeGridData.apply(this, arguments);


            return postData;
          },

          beforeProcessing: function (data) {
            _.each(data, function (dataRow) {
              if (!dataRow.toInvoice) {
                dataRow.toInvoice = 'false';
              } else if (dataRow.toInvoice && !dataRow.invoiceFileUid) {
                dataRow.toInvoice = 'true';
              } else if (dataRow.toInvoice && dataRow.invoiceFileUid) {
                dataRow.toInvoice = dataRow.invoiceFileUid;
              }

            });
          },

          dateFormatter: function (cellvalue) {
            var date = dateConverter.toDateFormatString(cellvalue),
              time = dateConverter.toTimeFormatString(cellvalue);

            return '<span class="cell-date">' + date + ' ' + time + '</span>';
          },

          gridComplete: function () {
            var supplierNameSearchField = that.$el.find('[name="productOwner"]');
            supplierNameSearchField.css('border-bottom', '1px solid lightgrey');
            supplierNameSearchField.attr('placeholder', _.i18n('offerList.productOwner'));
            var supplierNumberSearchField = that.$el.find('[name="supplierNumber"]');
            if (supplierNumberSearchField && supplierNumberSearchField.length < 2) {
              supplierNumberSearchField.attr('placeholder', _.i18n('orders.supplierNumber'));
              supplierNameSearchField.after(supplierNumberSearchField.parent().html());
            }
            var actionRequireField = that.$el.find('[name="actionRequired"]');

            var isLastMessageFromCustomerField = that.$el.find('[name="isLastMessageByCustomer"]');
            if (isLastMessageFromCustomerField && isLastMessageFromCustomerField.length < 2) {
              actionRequireField.after(isLastMessageFromCustomerField.parent().html());
            }
            var purchaseOrderId = UrlUtil.parseQueryString().purchaseOrderId;
            if (purchaseOrderId) {
              UrlUtil.clearQueryString();
              that.preselectFirstRow();
            }
            defaultsOptions.gridComplete.apply(this, arguments);
            that.checkSelection();
          },

          beforeSelectRow: function (rowid, event) {
            var shouldDownloadFile = $(event.target).hasClass('mdi-file-folder');
            if (shouldDownloadFile) {
              return false;
            }
            var grid = $(this);
            if (event.ctrlKey || event.altKey) {  // alt instead ctrl for mac os
              that.manageCtrlKey(grid, rowid);
            } else if (event.shiftKey) {
              that.manageShiftKey(grid, rowid);
            } else {
              return true;
            }
            return false;
          },

          onSelectRow: function (rowId, bool, e) {
            var cellUpdated = that.$('.cell-payedToManufacturer, .cell-payedByCustomer');
            if ($(e.target).hasClass('js-show-customer-messages')) {
              App.navigate('#orders/' + rowId + '/customer_messages', {trigger: true});
            } else if ($(e.target).hasClass('js-show-internal-messages')) {
              App.navigate('#orders/' + rowId + '/internal_messages', {trigger: true});
            } else if (e && e.type === 'click' && cellUpdated.has(e.target).length === 0 &&
              (App.getCurrentRoute().lastIndexOf('preconf_items') - App.getCurrentRoute().length) === -13 &&
              Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS]) {
              var route = App.getCurrentRoute() === 'preconf_items' ? App.getCurrentRoute() : 'preconf_items/' + App.getCurrentRoute();
              route = route.split('preconf_items').join('orders');
              App.navigate(route + '/' + rowId, {trigger: true});
            }
          }
        };

      options.colModel.push({
        label: ' ',
        name: 'snapshotsUids',
        align: 'left',
        classes: 'offer-link image-cell',
        formatter: this.pictureUidFormatter,
        width: 80,
        search: false
      });
      options.colModel.push({
        label: _.i18n('offerList.preConfItemId'),
        name: 'purchaseOrderId',
        classes: 'offer-link allowContextMenu contextMenu',
        formatter: this.numberFormatter,
        search: true,
        index: 'purchaseOrderId',
        key: true,
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('offerList.offerCreatDate'),
        name: 'createDate',
        classes: 'offer-link',
        formatter: this.dateFormatter,
        search: true,
        index: 'createDate',
        sorttype: 'date',
        searchrules: {date: true},
        searchoptions: {
          dataInit: datePickerPopoverMixin.jqGridDataInit
        },
        width: 100,
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('offerList.productOwner'),
        name: 'productOwner',
        classes: 'offer-link',
        formatter: this.supplierPimFormatter,
        search: true,
        index: 'productOwner',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('offerList.productCode'),
        name: 'productBaseCode',
        classes: 'offer-link',
        formatter: this.defaultFormatter,
        search: true,
        width: 100,
        index: 'productCode',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('offerList.productName'),
        name: 'productName',
        classes: 'offer-link',
        formatter: this.defaultFormatter,
        search: true,
        sortable: false,
        index: 'productName',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('common.quantity'),
        name: 'quantity',
        classes: 'context-menu order-link',
        formatter: this.defaultFormatter,
        search: true,
        sortable: false,
        width: 60,
        index: 'quantity',
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });
      options.colModel.push({
        label: _.i18n('offerList.status'),
        name: 'status',
        classes: 'offer-link',
        search: true,
        index: 'status',
        formatter: this.commandTypeFormatter,
        stype: 'select',
        searchrules: {select: true},
        searchoptions: {
          value: data.statuses,
          defaultValue: that.selectDefault
        },
        cellattr: function (rowId, cellValue, rowObject) {
          return displayCommentInToolTip(cellValue, rowObject);
        }
      });

      options = _.defaults(options, defaultsOptions);

      return options;
    },

    manageCtrlKey: function (grid, rowid) {
      var maxSelectedPreconfItemsNumber = 100,
        $row = grid.find('#' + rowid);
      if ($row.hasClass('selected')) {
        $row.removeClass('selected');
        this.onRowMultiselect(rowid, false);
      } else {
        if (this.selectedPreconfItems.length === maxSelectedPreconfItemsNumber) {
          this.showWarningSelectedNumberOutOfRange();
        } else {
          $row.addClass('selected');
          this.onRowMultiselect(rowid, true);
        }
      }
    },

    manageShiftKey: function (grid, rowid) {
      var firstSelected = this.getFirstSelected(),
        lastSelectedRow = grid.find('#' + rowid),
        gridRows = grid.find('tr'),
        lastIndex = gridRows.index(lastSelectedRow),
        lastSelected = {
          rowid: rowid,
          page: this.pagination.currentPage,
          index: lastIndex
        };

      if (!firstSelected) firstSelected = lastSelected;
      if (firstSelected.page > lastSelected.page) {
        this.swap(firstSelected, lastSelected);
      } else if (firstSelected.page === lastSelected.page) {
        if (firstSelected.index > lastSelected.index) {
          this.swap(firstSelected, lastSelected);
        }
      }
      if (this.checkIfOnlyCurrentPageSelection(firstSelected, lastSelected)) {
        this.selectWithoutRequest(firstSelected, lastSelected);
      } else {
        this.getCollectionToPage(firstSelected, lastSelected);
      }
    },

    checkIfOnlyCurrentPageSelection: function (first, last) {
      return first.page === last.page;
    },

    selectWithoutRequest: function (first, last) {
      var grid = this.ui.jqGrid,
        list = grid.find('tr');

      this.selectedPreconfItems = [];
      list.each(_.bind(function (index, row) {
        var $row = $(row),
          rowid = $row.attr('id');
        if (index >= first.index &&
          index <= last.index) {
          this.selectedPreconfItems.push({
            rowid: rowid,
            page: this.pagination.currentPage,
            index: index
          });
        }
      }, this));
      this.checkSelection();
    },

    swap: function (first, last) {
      for (var key in last) {
        var temp = first[key];
        first[key] = last[key];
        last[key] = temp;
      }
    },

    getFirstSelected: function () {
      var firstSelected,
        lastPage = this.getLastPage(),
        firstIndex = this.pagination.pageSize;
      if (this.selectedPreconfItems.length === 0) {
        return null;
      } else {
        _.each(this.selectedPreconfItems, function (item) {
          if (item.page < lastPage) {
            lastPage = item.page;
            firstIndex = item.index;
            firstSelected = item;
          } else if (item.page === lastPage) {
            if (item.index < firstIndex) {
              firstSelected = item;
              firstIndex = item.index;
            }
          }
        });
        return firstSelected;
      }
    },

    getLastPage: function () {
      var lastPage;
      if (this.selectedPreconfItems.length > 0) {
        lastPage = _.max(this.selectedPreconfItems, function (item) {
          return item.page;
        }).page;
      } else {
        lastPage = this.pagination.currentPage;
      }
      return lastPage;
    },

    getCollectionToPage: function (first, last) {
      var firstIndex = (first.page - 1) * this.pagination.pageSize + (first.index - 1),
        lastIndex = (last.page - 1) * this.pagination.pageSize + last.index,
        size = lastIndex - firstIndex || 1,
        params = {
          pageSize: size,
          first: firstIndex,
          _search: false,
          nd: new Date().getTime(),
          rows: size,
          page: 1,
          sord: 'asc'
        };
      if (size > 100) {
        this.showWarningSelectedNumberOutOfRange();
      } else {
        $('#content-blinder').show();
        this.trigger('onLoadSelectedPreconfItems', first, last, params);
      }
    },

    showWarningSelectedNumberOutOfRange: function () {
      bootbox.alert(_.i18n('common.errorOccuredSelectedItemsNumberOutOfRange'), function () {
        return;
      });
    },

    onSelectPreconfItem: function (first, last, items) {
      var pageSize = this.pagination.pageSize,
        page, itemIndex;

      this.selectedPreconfItems = [];
      _.each(items, _.bind(function (item, index) {
        page = Math.floor((index + first.index - 1) / pageSize);
        itemIndex = index + first.index - page * pageSize;
        this.selectedPreconfItems.push({
          rowid: item,
          page: page + first.page,
          index: itemIndex
        });
      }, this));
      this.checkSelection();
    },

    onRowMultiselect: function (rowid, select) {
      var index,
        grid = this.ui.jqGrid,
        gridList = grid.find('tr'),
        row = grid.find('#' + rowid),
        item = {
          rowid: rowid,
          page: this.pagination.currentPage,
          index: gridList.index(row)
        };
      if (select) {
        this.selectedPreconfItems.push(item);
      } else {
        index = this.selectedPreconfItems.indexOf(_.findWhere(this.selectedPreconfItems, {rowid: rowid}));
        this.selectedPreconfItems.splice(index, 1);
      }
      this.onSelectedPreonfItemChanged();
    },

    createActionButtonView: function () {
      this.actionsButtonView = this._getActionButtonsView();
      this.listenTo(this.actionsButtonView, 'action', this._onAction);
      this.getRegion('actionsRegion').show(this.actionsButtonView);
      this.actionsButtonView.setButtonsState({
        'proofsheet': false,
        'export': false
      });
    },

    _getActionButtonsView: function () {
      var actions = ['proofsheet', 'export'],
        actionsCollection = new Backbone.Collection();
      _.each(actions, function (action) {
        actionsCollection.push(availableActions[action]);
      });

      return new ActionButtonsView({
        collection: actionsCollection,
        dontShowIcons: true
      });
    },

    _onAction: function (action) {
      switch (action) {
        case 'proofsheet':
          this.downloadProofsheets();
          break;
        case 'export':
          this.exportItems();
          break;
        default :
          throw 'Action is not supported';
      }
    },

    checkSelection: function () {
      var $list = this.ui.jqGrid.find('tr');
      $list.each(_.bind(function (index, item) {
        var $item = $(item);
        if (_.some(this.selectedPreconfItems, {rowid: $item.attr('id')})) {
          $item.addClass('selected');
        } else {
          $item.removeClass('selected');
        }
      }, this));
      this.onSelectedPreonfItemChanged();
    },

    onSelectedPreonfItemChanged: function () {
      if (this.selectedPreconfItems.length > 0) {
        this.actionsButtonView.setButtonsState({
          'proofsheet': true,
          'export': true
        });
      } else {
        this.actionsButtonView.setButtonsState({
          'proofsheet': false,
          'export': false
        });
      }
      Settings.set('selectedPreconfItems', this.selectedPreconfItems);
    },

    downloadProofsheets: function () {
      this.downloadPdf('prf');
    },

    exportItems: function () {
      this.downloadPdf('pzi');
    },

    downloadPdf: function (docType) {
      var items = [];
      _.each(this.selectedPreconfItems, function (item) {
        items.push(item.rowid);
      });
      window.open(App.request('preconf-items:get-pdf-url', {
        docType: docType,
        poi: items
      }));
    },

    personalizedFormatter: function (cellvalue, options, rowObj) {
      var checked = rowObj.personalized ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input disabled="disabled" type="checkbox" data-ticket-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-urgent" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    payedByCustomerFormatter: function (cellValue, options, rowObj) {
      var checked = rowObj.payedByCustomer ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input  type="checkbox" data-preconf-item-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-payed-by-customer" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    payedToManufacturerFormatter: function (cellValue, options, rowObj) {
      var checked = rowObj.payedToManufacturer ? 'checked' : '',
        htmlEl = '<div class="m-l-15">' +
          '<input type="checkbox" data-preconf-item-cid="' + options.rowId +
          '" class="cpz-checkbox js-ticket-payed-to-manufacturer" ' + checked + ' ' +
          '></div>';
      return htmlEl;
    },

    numberFormatter: function (cellvalue) {
      return '<span class="cell-default jqgridContextMenuCell" data-row-id="' + cellvalue + '">' + cellvalue + '</span>';
    },

    commandTypeFormatter: function (cellValue, options) {
      if (cellValue === null || cellValue === undefined) {
        cellValue = '';
      }

      var statuses = [], statusValue;

      if (options.colModel.searchoptions.value) {
        statuses = options.colModel.searchoptions.value.split(';');
      }

      _.each(statuses, function (status) {
        var st = status.split(':');
        if (st.length === 2) {
          if (st[0] === cellValue) {
            statusValue = st[1];
          }
        }
      });

      if (!statusValue) {
        statusValue = _.i18n('commandstatus.' + cellValue.toLowerCase());
      }

      return '<span class="cell-default" data-row-id="' +
        options.rowId + '">' + statusValue + '</span>';
    },

    supplierPimFormatter: function (cellValue, options, model) {
      if (cellValue === null || cellValue === undefined) {
        cellValue = '';
      }

      if (model.pim) {
        return '<div class="col-left name-holder pim-icon m-l-0" style="height: 18px; ' +
          'text-orientation: unset; writing-mode: unset; letter-spacing: unset;">' +
          '    <label>PIM</label>\n' +
          '</div><span class="cell-default" data-row-id="' +
          options.rowId + '">' + cellValue + '</span>';
      } else {
        return '<span class="cell-default" data-row-id="' +
          options.rowId + '">' + cellValue + '</span>';
      }
    },

    invoiceFormatter: function (cellvalue) {
      var insertHTML;
      var fileClass;
      if (cellvalue === 'false') {
        insertHTML = '';
      } else if (cellvalue === 'true') {
        insertHTML = '';
        fileClass = 'mdi-file-folder-open';
      } else {
        insertHTML = '<a target="_blank" href="' +
          Settings.url('file', cellvalue, {cmds: 'on'}) +
          '"><i class="mdi-file-folder" title="Payed by customer" aria-hidden="true"></i></a>';
      }

      var htmlEl = '<div class="' + fileClass + '">' + insertHTML + '</div>';
      return htmlEl;
    },
    actionRequiredFormatter: function (cellvalue, options) {
      var insertHTML, actionHTML;
      switch (options.colModel.name) {
        case 'actionRequired':
          actionHTML = 'class="mdi-action-markunread-mailbox js-show-customer-messages" title="' +
            _.i18n('offerList.actionRequired') + '"';
          break;
        case 'actionRequiredInternal':
          actionHTML = 'class="mdi-editor-mode-comment js-show-internal-messages" title="' +
            _.i18n('offerList.actionRequiredInternal') + '"';
          break;
        case 'actionRequiredUkr':
          actionHTML = 'class="mdi-image-color-lens js-show-internal-messages" title="' +
            _.i18n('offerList.actionRequiredUkr') + '"';
          break;
      }
      if (cellvalue === false) {
        insertHTML = '';
      } else if (cellvalue === true) {
        insertHTML = '<i ' + actionHTML + ' aria-hidden="true">';
      }

      var htmlEl = '<div>' + insertHTML + '</div>';
      return htmlEl;
    },

    updateExportUrl: function (data) {
      this.$el.find('.preconf-items-export').attr('href', App.request('preconf-items:get-excel-url', data));
    },

    onGridFilterChange: function () {
      var that = this,
        filters = {},
        value;

      _.each(this.colModel, function (column) {
        if (column.search) {
          if (column.stype === 'select') {
            value = that.$('select[name="' + column.index + '"]').val();
            filters[column.index] = value === that.selectDefault ? '' : value;
          } else if (column.sorttype === 'date') {
            value = that.$('input[name="' + column.index + '"]').val();
            if (column.index === 'createDate' && value) {
              filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
            }
          } else {
            value = that.$('input[name="' + column.index + '"]').val();
            filters[column.index] = value;
          }
        }
      });

      this.filters = filters;
      this.filterChange = true;
      this.updatePagination(true);
      this.updateExportUrl(filters);
    }
  });

  module.exports = PreconfItemsView;
});

